class InstalatorActivationUsersController {
  static controller($scope, $state, $stateParams, InstalatorRegistrationService, $translate) {
    'ngInject';

      console.log('$state.params', $state.params);
      $translate.use($state.params.lang);
      InstalatorRegistrationService.activateAccount($state.params.idNumber, $state.params.token).then(function(data){
          $state.go('public.users.instalator.instalator-confirmed');
      });
  };
}

export default InstalatorActivationUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/instalator/instalator-activation.users.controller.js